'use strict';

exports.__esModule = true;
exports.getVersionCheck = getVersionCheck;
exports.getVersion = getVersion;

var _http = require('./../network/http');

var API = {
  RELEASES_VERSION_CHECK: '/releases/version_check',
  RELEASES_VERSION: '/releases/version'
};

/**
 * Wrapper for `/releases` API endpoint
 */

var releases = {
  getVersionCheck: getVersionCheck,
  getVersion: getVersion
};

exports.default = releases;

/**
 * Check version
 * @param {object} - version as a string
 * @returns {promise} containing response "OK" for valid version
 */

function getVersionCheck(params) {
  return (0, _http.get)(API.RELEASES_VERSION_CHECK, params);
}

/**
 * Get all available versions
 * @returns {promise} containing all versions
 */
function getVersion() {
  return (0, _http.get)(API.RELEASES_VERSION);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/releases/releases.js
// module id = 1100
// module chunks = 0